/**
 * Created by Анжелика on 31.08.2017.
 */
import React from 'react';

const Button = (props) => {
    return (
        <button type="button" {...props}></button>
    );
};

export default Button;


// WEBPACK FOOTER //
// ./src/components/Button.js